import AsyncStorage from "@react-native-async-storage/async-storage";
import { setGoHome } from "../Redux/Reducers/appConfigReducer";
import { setCurrentWidget } from "../Redux/Reducers/deviceConfigReducer";
import { inAppBrowserFunc } from "./inAppBrowser/inAppBrowser";
import { IFRAME_RENDERER } from "../navigation/StackNavigator/routes";
import { Platform } from "react-native";

export const handleMessageEventListener = (event, webviewRef, navigate) => {
    return async (dispatch, getState) => {        
        try {
            let message = event?.data || event?.nativeEvent?.data ? event.data || event?.nativeEvent?.data : null;

            if(typeof message === "string") message = JSON.parse(message);

            if (!message || !message.type) return;

            switch (message.type) {
                case 'INNSPIRE_GO_HOME':
                    dispatch(setGoHome(true));
                    break;

                case 'INNSPIRE_ROUTE_TO': {
                    const { url, metaData = {}, app_route } = message.payload;
                    if (app_route) {
                        dispatch(setCurrentWidget({ widgetType: 'RANDOM WIDGET TYPE', targetUrl: url, ...metaData }))

                        // Need to be resolved
                        navigate.navigate(app_route);
                    }
                    break;
                }

                case 'INNSPIRE_SAVE_DATA': {
                    const { key, value } = message.payload;
                    await AsyncStorage.setItem(key, value);
                    break;
                }

                case 'INNSPIRE_GET_DATA': {
                    const dataKeys = message.payload.key || [];
                    const responseData = {};

                    for (let key of dataKeys) {
                        const storedData = await AsyncStorage.getItem(key);
                        if (storedData) responseData[key] = storedData;
                    }

                    if(Platform.OS === "web") {
                        webviewRef?.current?.contentWindow?.postMessage(
                            {
                                type: 'INNSPIRE_DATA_TO_IFRAME',
                                payload: responseData,
                            },
                            '*'
                        );
                    } else {
                        webviewRef?.current?.postMessage(
                            JSON.stringify({
                                type: 'INNSPIRE_DATA_TO_IFRAME',
                                payload: responseData,
                            })
                        );
    
                    }
                    break;
                }

                case 'INNSPIRE_OPEN_URL': {
                    const targetUrl = message.payload?.url;

                    inAppBrowserFunc(targetUrl)
                    break;
                }

                default:
                    console.log('Unhandled message type:', message.type);
            }
        } catch (error) {
            console.error('Error handling message:', error);
        }
    }
};